import { NgModule } from '@angular/core';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { TranslateModule } from '@ngx-translate/core';
import { OperatorsListModule } from '../operators-list/operators-list.module';
import { DiscussionsComponent } from './discussions.component';
import { TinyMCEEditorModule } from '../editor/editor.module';
import { CommonModule } from '@angular/common';
import { LoadingModule } from '../loading/loading.module';
import { AutoSaveModule } from 'common/auto-save/auto-save.module';
import { DiscussionsService } from './discussions.service';
import { DiscussionsMessagesService } from './discussions-messages/discussions-messages.service';
import { DiscussionsMessagesComponent } from './discussions-messages/discussions-messages.component';
import { AlertBoxModule } from '../alert-box/alert-box.module';

@NgModule({
  imports: [
    TranslateModule.forChild(),
    OperatorsListModule,
    SvgIconModule,
    TinyMCEEditorModule,
    CommonModule,
    LoadingModule,
    AutoSaveModule,
    AlertBoxModule
  ],
  declarations: [
    DiscussionsComponent,
    DiscussionsMessagesComponent
  ],
  exports: [
    DiscussionsComponent
  ],
  providers: [
    DiscussionsService,
    DiscussionsMessagesService
  ]
})
export class DiscussionsModule {}
